module.exports = __webpack_public_path__ + "static/media/banner2@2x.991be528.png";